// import "@fontsource/roboto/300.css";
// import "@fontsource/roboto/400.css";
// import "@fontsource/roboto/500.css";
// import "@fontsource/roboto/700.css";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { faIR as data_grid_farsi } from "@mui/x-data-grid/locales";
import { faIR as date_pickers_farsi } from "@mui/x-date-pickers/locales";
import { faIR } from "@mui/material/locale";
import { extendTheme, ThemeProvider } from "@mui/material";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "./layout/layout";
import Dashboard from "./pages/dashboard/dashboard";
import SignIn from "./pages/auth/SignIn";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./context/auth";
import { DashboardDataProvider } from "./context/dashboard-data";
import { TasksDataProvider } from "./context/tasks-data";
import { TaskDialogProvider } from "./context/task-dialog";
import { NotificationsProvider } from "@toolpad/core/useNotifications";
import { HelmetProvider } from "react-helmet-async";
import { clearAllApplicationCaches } from "./utilities/cacheCleaner";

import BaseDefinitions from "./pages/base-definition/base-definitions";
import Province from "./pages/province/province";
import Bank from "./pages/bank/bank";
import User from "./pages/users/user";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFnsJalali } from "@mui/x-date-pickers/AdapterDateFnsJalaliV3";
import TaskUser from "./pages/tasks/task-user";
import Services from "./pages/services/services";
import Agreements from "./pages/agreements/agreements";
import FollowUpGroups from "./pages/followup-groups/followup-groups";
import SalesFunnelList from "./pages/sales-funnel/sales-funnel";
import SystemWeb from "./pages/systems/system-web";
import TabTypeSchedule from "./pages/followups-schedule/tab-type-schedule";
import BaseAgreements from "./pages/base-agreements/base-agreements";
import Transactions from "./pages/transactions/transactions";
import PayFactor from "./pages/Customers/PayFactor/PayFactor";
import ResultPay from "./pages/result-pay/result-pay";
import Processes from "./pages/processes/processes";
import ProcessSections from "./pages/process-sections/process-sections";
import SmsList from "./pages/sms/sms-list";
import SmsHistoryPage from "./pages/sms/sms-history";

const ErrorPage = () => {
  return <h1>صفحه مورد نظر پیدا نشد</h1>;
};
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/sign-in",
        Component: SignIn,
      },

      {
        path: "/",
        Component: Layout,
        errorElement: <ErrorPage />,
        children: [
          {
            path: "/",
            Component: Dashboard,
          },
          {
            path: "/works",
            Component: Dashboard,
          },

          {
            path: "users",
            Component: User,
          },
          {
            path: "users/:roleName",
            Component: User,
          },
          {
            path: "base",
            Component: BaseDefinitions,
          },
          {
            path: "setting/systems",
            Component: SystemWeb,
          },
          {
            path: "base/provinces",
            Component: Province,
          },
          {
            path: "base/banks",
            Component: Bank,
          },
          {
            path: "base/cities",
            Component: Bank,
          },
          {
            path: "tasks",
            Component: TaskUser,
          },
          {
            path: "sales-funnel",
            Component: SalesFunnelList,
          },
          {
            path: "followups-schedule",
            Component: TabTypeSchedule,
          },
          {
            path: "transactions",
            Component: Transactions,
          },

          {
            path: "agreements",
            Component: Agreements,
          },
          {
            path: "agreements/services",
            Component: Services,
          },
          {
            path: "agreements/base",
            Component: BaseAgreements,
          },
          {
            path: "agreements/followup-groups",
            Component: FollowUpGroups,
          },
          {
            path: "processes",
            Component: Processes,
          },
          {
            path: "setting/process-sections",
            Component: ProcessSections,
          },
          {
            path: "setting/sales",
            Component: SmsList,
          },
          {
            path: "setting/sms-history",
            Component: SmsHistoryPage,
          },
        ],
      },
    ],
  },
  {
    path: "/pay/:customerId",
    Component: PayFactor,
    errorElement: <ErrorPage />,
  },
  {
    path: "result-pay",
    Component: ResultPay,
  },
]);
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const demoTheme = extendTheme(
  {
    typography: {
      fontFamily: ["IRANSansXFaNum"].join(","),
    },
    colorSchemes: { light: true, dark: true },
    colorSchemeSelector: "class",
    direction: "rtl",

    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 600,
        lg: 1200,
        xl: 1536,
      },
    },
  },
  data_grid_farsi,
  date_pickers_farsi,
  faIR
);
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const queryClient = new QueryClient();

// پاک کردن کش‌ها به صورت خودکار در فایل cacheCleaner.ts مدیریت می‌شود
// clearAllApplicationCaches().then(() => {
//   console.log('🧹 کش‌های برنامه پاک شدند');
// });

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <CacheProvider value={cacheRtl}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <DashboardDataProvider>
              <TasksDataProvider>
                <TaskDialogProvider>
                  <ThemeProvider theme={demoTheme}>
                    <NotificationsProvider>
                      <LocalizationProvider dateAdapter={AdapterDateFnsJalali}>
                        <RouterProvider router={router} />
                      </LocalizationProvider>
                    </NotificationsProvider>
                  </ThemeProvider>
                </TaskDialogProvider>
              </TasksDataProvider>
            </DashboardDataProvider>
          </AuthProvider>
        </QueryClientProvider>
      </CacheProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
